exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SimilarListings-paddingmobile-2LJhj {\n    padding: 5px 0px !important;\n}\n.SimilarListings-similarListingMargin-30ctG{\n    margin: 0 -15px;\n}", ""]);

// exports
exports.locals = {
	"paddingmobile": "SimilarListings-paddingmobile-2LJhj",
	"similarListingMargin": "SimilarListings-similarListingMargin-30ctG"
};